export default __webpack_public_path__ + "static/media/AnnualHealth.9b20ee20.webp";